import { useCallback, useMemo } from 'react';

import { SelectedTagValues, TagsMenuItem, TagValues } from '../../../types';
import { ControlledByMap, ControllingTagsMap, SourceToTargetMap, TagsIdToNameMap } from '../types';
import {
  getControlledByMap,
  getControllingTagsMap,
  getFilteredSelectedValues as getSelectedValues,
  getSourceToTargerMap,
  getTagIdToNameMap,
} from '../utils';

type Props = {
  tags: TagsMenuItem[];
  selectedTagValues?: SelectedTagValues;
};

export default function useTagsControlled(props: Props) {
  const { tags, selectedTagValues } = props;

  const controlledByMap: ControlledByMap = useMemo(() => getControlledByMap(tags), [tags]);

  const tagsIdToNameMap: TagsIdToNameMap = useMemo(() => getTagIdToNameMap(tags), [tags]);

  const sourceToTargetMap: SourceToTargetMap = useMemo(() => getSourceToTargerMap(tags), [tags]);

  const controllingTagsMap: ControllingTagsMap = useMemo(
    () => getControllingTagsMap(controlledByMap),
    [controlledByMap],
  );

  const getFilteredSelectedValues = useCallback(
    (tagId: string, val: TagValues) =>
      getSelectedValues({
        controllingTagsMap,
        sourceToTargetMap,
        tagId,
        val,
        selectedTagValues,
      }),
    [controllingTagsMap, selectedTagValues, sourceToTargetMap],
  );

  // console.log('enableControllingTags', enableControllingTags);
  // console.log('tags', tags);
  // console.log('selectedTagValues', selectedTagValues);
  // console.log('controlledByMap', controlledByMap);
  // console.log('sourceToTargetMap', sourceToTargetMap);
  // console.log('controllingTagsMap', controllingTagsMap);

  return {
    controlledByMap,
    sourceToTargetMap,
    tagsIdToNameMap,
    getFilteredSelectedValues,
  };
}
